export var ECaptionVariant;
(function (ECaptionVariant) {
    ECaptionVariant["Default"] = "default";
    ECaptionVariant["Success"] = "success";
    ECaptionVariant["Warning"] = "warning";
    ECaptionVariant["Error"] = "error";
})(ECaptionVariant || (ECaptionVariant = {}));
